module.exports = __webpack_public_path__ + "img/kommune-545.3cff1899.svg";